import { useEffect, useState } from "react";
import { ORDER_PAYMENT_CHANNELS } from "@cyh/contracts";
import { api } from "../api";
import { useLanguage } from "../i18n";

export function OrderPaymentChannelSelect({defaultValue="",onError}:{defaultValue?:string;onError?:(message:string)=>void}){
  const {t}=useLanguage();
  const [options,setOptions]=useState<string[]>([]);
  const [selected,setSelected]=useState(defaultValue);
  const [failed,setFailed]=useState(false);
  useEffect(()=>{let active=true;api.orderPaymentChannels().then(rows=>{
    if(!active)return;
    const available=ORDER_PAYMENT_CHANNELS.filter(name=>rows.includes(name));
    setOptions(available);
    setSelected(current=>available.includes(current as typeof ORDER_PAYMENT_CHANNELS[number])?current:"");
    setFailed(false);
  }).catch(cause=>{if(!active)return;setFailed(true);onError?.(cause instanceof Error?cause.message:String(cause));});return()=>{active=false;};},[]);
  return <><select name="paymentChannel" required value={selected} onChange={event=>setSelected(event.target.value)} disabled={failed||options.length===0}>
    <option value="" disabled>{t("请选择","Select")}</option>
    {options.map(name=><option value={name} key={name}>{name}</option>)}
  </select>{options.length===0&&<small>{failed?t("收款账户加载失败，请重试","Could not load accounts; please retry"):t("暂无可用的指定收款账户","No eligible receipt accounts")}</small>}</>;
}
